import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_oss_date_picker_filled = _resolveComponent("oss-date-picker-filled")!
  const _component_AccountableAccountVue = _resolveComponent("AccountableAccountVue")!
  const _component_v_select_filled = _resolveComponent("v-select-filled")!
  const _component_oss_text_field_filled = _resolveComponent("oss-text-field-filled")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createBlock(_component_v_form, {
    modelValue: _ctx.formValid,
    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formValid) = $event))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, {
        "no-gutters": "",
        class: "d-flex justify-space-around"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "12" }, {
            default: _withCtx(() => [
              _createElementVNode("h4", null, _toDisplayString(_ctx.mode === "document" ? "Indiquer un intitulé" : "Intitulé"), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, {
        "no-gutters": "",
        class: "d-flex justify-space-around mt-2"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "12" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_text_field_filled, {
                modelValue: _ctx.title,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.title) = $event)),
                type: "text",
                placeholder: "Ex: Total, Paul...",
                mandatory: true,
                disabled: _ctx.mode === 'bank',
                rules: [(v) => !!v || _ctx.$t('settings.itemRequired')]
              }, null, 8, ["modelValue", "disabled", "rules"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, {
        "no-gutters": "",
        class: "d-flex justify-space-around mt-4"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "6" }, {
            default: _withCtx(() => [
              _createElementVNode("h4", null, _toDisplayString(_ctx.mode === "document" ? "Indiquer la date" : "Date"), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, { class: "pl-2" }, {
            default: _withCtx(() => _cache[7] || (_cache[7] = [
              _createElementVNode("h4", null, "Nature de l'opération", -1)
            ])),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, {
        "no-gutters": "",
        class: "d-flex justify-space-around mt-2"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "6" }, {
            default: _withCtx(() => [
              _createVNode(_component_oss_date_picker_filled, {
                modelValue: _ctx.date,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.date) = $event)),
                filterWithoutClosedAccountingPeriods: true,
                "hide-details": "",
                textFieldReadOnly: false,
                disabled: _ctx.mode === 'bank'
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "6",
            class: "pl-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_AccountableAccountVue, {
                showLabel: true,
                showValidation: false,
                companyId: _ctx.companyId,
                inAccountableAccountType: "IncomingOutgoing",
                publishedAccounts: true,
                title: "Nature de l'opération",
                onSelectAccountableAccount: _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectOperationType($event)))
              }, null, 8, ["companyId"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, {
        "no-gutters": "",
        class: "d-flex justify-space-around mt-4"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: _ctx.subjectToVAT ? 4 : 6
          }, {
            default: _withCtx(() => [
              (_ctx.subjectToVAT)
                ? (_openBlock(), _createElementBlock("h4", _hoisted_1, "Taux de TVA"))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["cols"]),
          (_ctx.subjectToVAT)
            ? (_openBlock(), _createBlock(_component_v_col, {
                key: 0,
                cols: "4",
                class: "pl-2"
              }, {
                default: _withCtx(() => _cache[8] || (_cache[8] = [
                  _createElementVNode("h4", null, "Montant TVA", -1)
                ])),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_v_col, {
            cols: _ctx.subjectToVAT ? 4 : 6,
            class: "pl-2"
          }, {
            default: _withCtx(() => [
              _createElementVNode("h4", null, _toDisplayString(_ctx.subjectToVAT ? "Montant TTC" : "Montant"), 1)
            ]),
            _: 1
          }, 8, ["cols"])
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, {
        "no-gutters": "",
        class: "d-flex justify-space-around mt-2"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: _ctx.subjectToVAT ? 4 : 6
          }, {
            default: _withCtx(() => [
              (_ctx.subjectToVAT)
                ? (_openBlock(), _createBlock(_component_v_select_filled, {
                    key: 0,
                    items: _ctx.vatRates,
                    "item-value": "value",
                    "item-title": "text",
                    modelValue: _ctx.vatRateValue,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.vatRateValue) = $event))
                  }, null, 8, ["items", "modelValue"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["cols"]),
          (_ctx.subjectToVAT)
            ? (_openBlock(), _createBlock(_component_v_col, {
                key: 0,
                cols: "4",
                class: "pl-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_oss_text_field_filled, {
                    suffix: "€",
                    disabled: true,
                    modelValue: _ctx.vatAmount,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.vatAmount) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_v_col, {
            cols: _ctx.subjectToVAT ? 4 : 6,
            class: "pl-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_oss_text_field_filled, {
                modelValue: _ctx.grossAmount,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.grossAmount) = $event)),
                suffix: "€",
                mandatory: true,
                disabled: _ctx.mode === 'bank'
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }, 8, ["cols"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}